import {
  AcceptIcon,
  CloseIcon,
  Flex,
  HighlightIcon,
  InfoIcon,
  QuestionCircleIcon,
  Text,
} from "@fluentui/react-northstar";
import { Col, Row } from "antd";
import "./AnnotationsSummary.scss";
import MenuBookIcon from "@mui/icons-material/MenuBook";

const annotationTypes = {
  highlight: {
    type: "highlight",
    icon: HighlightIcon,
    label: "Highlight",
    color: "#faad14",
    borderColor: "#faad14",
  },
  suggestion: {
    type: "suggestion",
    icon: InfoIcon,
    label: "Suggestion",
    color: "#1890ff",
    borderColor: "#ffde9b9c",
  },
  correction: {
    type: "correction",
    icon: CloseIcon,
    label: "Correction",
    color: "#ff4d4f",
    borderColor: "#ff4d4f",
  },
  praise: {
    type: "praise",
    icon: AcceptIcon,
    label: "Praise",
    color: "#52c41a",
    borderColor: "#52c41a",
  },
  question: {
    type: "question",
    icon: QuestionCircleIcon,
    label: "Question",
    backgroundColor: "#eae6ff",
    color: "#6264a7",
  },
  reference: {
    type: "reference",
    icon: MenuBookIcon,
    label: "Reference",
    backgroundColor: "#c2410c10",
    color: "#c2410c",
  },
};

const AnnotationsSummary = ({ annotations, handleAnnotationClick }) => {
  return (
    <Flex gap="gap.small" column className="annotations-summary">
      <Text content="Annotations Summary" weight="semibold" />
      <Row gutter={[5, 5]}>
        {annotations.map((annotation) => {
          const annotationType = annotationTypes[annotation.type.toLowerCase()];
          return (
            <Col key={annotation.id}>
              <Flex
                gap="gap.smaller"
                className="annotation-item"
                vAlign="center"
                onClick={(e) => handleAnnotationClick(annotation.id, e)}
              >
                <annotationType.icon
                  outline
                  size="small"
                  style={{ color: annotationType.color }}
                />
                <Text content={annotationType.label} weight="semibold" />
              </Flex>
            </Col>
          );
        })}
      </Row>
    </Flex>
  );
};

export default AnnotationsSummary;
